import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../../firebase';
import { IconShieldCheck } from '@tabler/icons-react';
import Button from '../../components/ui/Button';

export default function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate('/dashboard');
    } catch (err) {
      setError('Invalid email or password.');
    }
    setLoading(false);
  };

  return (
    <div style={{
      height: '100vh', width: '100vw',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'var(--color-bg-secondary)',
    }}>
      <div style={{
        width: 360, padding: 32,
        background: 'var(--color-bg-primary)',
        borderRadius: 14,
        border: '0.5px solid var(--color-border-light)',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 28 }}>
          <div style={{
            width: 32, height: 32, borderRadius: 8,
            background: 'var(--color-brand)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <IconShieldCheck size={18} color="#fff" stroke={1.5} />
          </div>
          <div>
            <div style={{ fontSize: 16, fontWeight: 500 }}>Agriware HQ</div>
            <div style={{ fontSize: 10, color: 'var(--color-text-tertiary)', letterSpacing: '0.04em' }}>INTERNAL ACCESS</div>
          </div>
        </div>

        <form onSubmit={handleLogin}>
          <div style={{ marginBottom: 12 }}>
            <label style={{ fontSize: 11, color: 'var(--color-text-secondary)', display: 'block', marginBottom: 4 }}>Email</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              autoFocus
              required
            />
          </div>
          <div style={{ marginBottom: 20 }}>
            <label style={{ fontSize: 11, color: 'var(--color-text-secondary)', display: 'block', marginBottom: 4 }}>Password</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
            />
          </div>

          {error && (
            <div style={{
              fontSize: 12, color: 'var(--color-danger)',
              background: 'var(--color-danger-light)',
              padding: '8px 12px', borderRadius: 6, marginBottom: 16,
            }}>{error}</div>
          )}

          <Button type="submit" fullWidth loading={loading}>Sign in</Button>
        </form>

        <div style={{ fontSize: 11, color: 'var(--color-text-tertiary)', marginTop: 20, textAlign: 'center' }}>
          Agriware staff only. Access requires HQ admin privileges.
        </div>
      </div>
    </div>
  );
}
